import React from "react";

type UnderlineFontProps = {
  color?: string;
};

const UnderlineFont: React.FC<UnderlineFontProps> = ({ color = "#000" }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 21V19H19V21H5ZM12 17C10.3167 17 8.89567 16.4207 7.737 15.262C6.579 14.104 6 12.6833 6 11V3H8.5V11C8.5 11.9833 8.83733 12.8127 9.512 13.488C10.1873 14.1627 11.0167 14.5 12 14.5C12.9833 14.5 13.8127 14.1627 14.488 13.488C15.1627 12.8127 15.5 11.9833 15.5 11V3H18V11C18 12.6833 17.4207 14.104 16.262 15.262C15.104 16.4207 13.6833 17 12 17Z"
        fill={color}
      />
    </svg>
  );
};

export default UnderlineFont;
